import { WhatsAppIcon } from "./icons";
import { WA } from "../data/site";

const WhatsAppFloat = () => (
    <a
        href={WA.general}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="whatsapp-floating-btn"
        aria-label="Chat with Paan Saga on WhatsApp"
        className="fixed bottom-5 right-5 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-saga-red text-saga-cream shadow-[0_12px_32px_rgba(105,0,3,0.35)] transition-transform duration-300 hover:scale-105"
    >
        <WhatsAppIcon className="h-6 w-6" />
    </a>
);

export default WhatsAppFloat;
